module.exports = __webpack_public_path__ + "img/frascos_azules.7367c0ac.svg";